import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import Heading from '../../components/cms/heading'
import Copy from '../../components/cms/copy'
import ModuleContainer from '../../components/cms/module-container'
import CTA from '../../components/cms/cta'
import ButtonGroup from '../../components/cms/button-group'
import {useSlotRecipe} from '@chakra-ui/react3'
import copyOnlySlotRecipe from './index.recipe'
import Fade from '../../components/cms/fade'

const CopyOnly = React.forwardRef(
    (
        {
            moduleId,
            moduleType,
            pageId,
            anchor,
            headingLevel,
            heading,
            copy,
            primaryCta,
            secondaryCta,
            alignment,
            background,
            spacing
        },
        ref
    ) => {
        const recipe = useSlotRecipe({recipe: copyOnlySlotRecipe})
        const styles = useMemo(() => recipe({alignment}), [recipe, alignment])

        return (
            <ModuleContainer
                moduleId={moduleId}
                moduleType={moduleType}
                pageId={pageId}
                anchor={anchor}
                background={background}
                spacing={spacing}
                css={styles.root}
                ref={ref}
            >
                <Fade>
                    <Heading {...heading} headingLevel={headingLevel} alignment={alignment} />
                </Fade>
                {copy?.text && (
                    <Fade>
                        <Copy {...copy} alignment={alignment}></Copy>
                    </Fade>
                )}
                {(primaryCta?.label || secondaryCta?.label) && (
                    <ButtonGroup {...styles.buttonGroup}>
                        {primaryCta?.label && (
                            <CTA
                                {...primaryCta}
                                variant="primary"
                                trackingContext={{moduleName: moduleType, eventLabel: 'primaryCta'}}
                            />
                        )}
                        {secondaryCta?.label && (
                            <CTA
                                {...secondaryCta}
                                variant="secondary"
                                trackingContext={{
                                    moduleName: moduleType,
                                    eventLabel: 'secondaryCta'
                                }}
                            />
                        )}
                    </ButtonGroup>
                )}
            </ModuleContainer>
        )
    }
)

if (process.env.NODE_ENV !== 'production') {
    CopyOnly.displayName = 'CopyOnly'
}

CopyOnly.propTypes = {
    anchor: PropTypes.string,
    headingLevel: PropTypes.number,
    heading: PropTypes.object,
    copy: PropTypes.object,
    primaryCta: PropTypes.object,
    secondaryCta: PropTypes.object,
    alignment: PropTypes.oneOf(['left', 'center']),
    background: PropTypes.oneOf(['default', 'subtle', 'strong', 'inverse']),
    spacing: PropTypes.oneOf(['default', 'reduced', 'min', 'min-top', 'min-bottom']),
    moduleId: PropTypes.string,
    moduleType: PropTypes.string,
    pageId: PropTypes.string
}

export default CopyOnly
